import {
    React,Component,BootstrapTable,
    paginationFactory,Button, ButtonToolbar, Card, Tabs, Tab, 
    Form, Col, Row, axios, Container, Banner, Typeahead, TimePicker,
    cellEditFactory, Type, moment, NavLink, Alert, AppConfiguration,
    NoserLoading, Noser, sizePerPageRenderer, DatePicker, Redirect
} 
from '../../noser-hris-component';
import { DropdownButton, Dropdown} from 'react-bootstrap';

import BlacklistModal from './Modal/BlacklistModal';
class JobOfferCreate extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userinfo        :   [],
            data            :   [],
            isloading       :   false,
            isshow          :   false,
            alerttype       :   "",
            message         :   "",
            color           :   "",
            fade            :   true,
            navigate        :   false,
            disablecard     :   false,
            disablebutton   :   false,
            minDate         :   "",

            /*JO Tab Details*/
            clientDDL       :   [],
            positionDDL     :   [],
            locationDDL     :   [],
            employmentDDL   :   [],
            paytypeDDL      :   [],
            paymodeDDL      :   [],
            paycardtypeDDL  :   [],
            taxexemptionDDL :   [],
            taxtypeDDL      :   [],
            taxcodeDDL      :   [],
            deductionDDL    :   [],
            basic13thMonthDDL:  [],
            tmnprofileDDL   :   [],
            yesNoDDL        :   [
                {"value":"0","label":"NO"},
                {"value":"1","label":"YES"}
            ],
            requiredDDL        :   [
                {"value":"0","label":"OPTIONAL"},
                {"value":"1","label":"MANDATORY"}
            ],
            documentGRID    :   [],

            profileId       :   "",
            applicationId   :   "",
            employeeName    :   "",
            clientId        :   "",
            clientName      :   "",
            positionId      :   "",
            position        :   "",

            locationId      :   "",
            isdefaultBranch :   "",
            employmentId    :   "",
            salaryRate      :   "",
            dateHired       :   '',
            contractstartDate:  '',
            contractendDate :   '',
            paytypeId       :   "",
            paymodeId       :   "",
            paycardtypeId   :   "",
            paycardNumber   :   "",
            tmnprofileId    :   "",
            ecolaRate       :   "",
            colaRate        :   "",
            seaRate         :   "",
            taxexemptionId  :   "",
            taxcodeId       :   "",
            isbasicPay      :   "",
            deductionsssId  :   "",
            deductionphicId :   "",
            deductionhdmfId :   "",
            basic13thmonthId:   "",
            daysperMonth    :   "",
            daysperYear     :   "",
            openModal:false,
            appplicationStatusId: "",
            applicationStatus:"",
            /*JO Tab End Details*/

            /*Applicant Info Tabs*/
            educationGrid:[],
            employmentGrid:[],
            fbGrid:[],
            referenceGrid:[],
            typeDDL: [
                {name: 'Select Address Type',   value: "",},
                {name: 'CURRENT ADDRESS',       value: '0',},
                {name: 'REGISTERED ADDRESS',    value: '1',},
                {name: 'PROVINCIAL ADDRESS',    value: "2",},
                {name: 'CORRESPONDENCE ADDRESS',value: '3',},
                {name: 'FOREIGN ADDRESS',       value: '4',},
            ],
            educationDDL  :    [
                {"name": 'Select Level', "value": "",},
                {"name":"COLLEGE","value":"0"},
                {"name":"HIGH SCHOOL","value":"1"},
                {"name":"SENIOR HIGH SCHOOL","value":"5"},
                {"name":"JUNIOR HIGH SCHOOL","value":"4"},
                {"name":"ELEMENTARY","value":"2"},
                {"name":"OTHERS","value":"3"},
            ],
            fbDDL  :    [
                {"name": 'Select Role', "value": "",},
                {"name":"FATHER",       "value":"0"},
                {"name":"MOTHER",       "value":"1"},
                {"name":"SPOUSE",       "value":"2"},
                {"name":"BROTHER",      "value":"3"},
                {"name":"SISTER",       "value":"4"},
                {"name":"CHILD",        "value":"5"},
            ],
            referenceDDL:[
                {"name": 'Select Role', "value": ""},
                {"name":"Previous Employment", "value" : "0"},
                {"name":"Neighbor", "value" : "1"}
            ],
            resumeFileName:"",
            pictureFileName:""
            /*End Applicant Info Tabs*/

        }
        this.state.userinfo = JSON.parse(sessionStorage.getItem("userData"))
        this.state.data = JSON.parse(sessionStorage.getItem("editapplicationform_" + this.state.userinfo.userId + this.state.userinfo.employeeId))
        
        this.state.applicationId   =   this.state.data.id
        this.state.profileId       =   this.state.data.profileId
        this.state.clientName      =   this.state.data.client
        this.state.clientId        =   this.state.data.clientId
        this.state.employeeName    =   this.state.data.employeeName
        this.state.position        =   this.state.data.position
        this.state.positionId      =   this.state.data.positionId
        this.state.applicationStatus = this.state.data.applicationStatusId==="0" ? "NEW APPLICATION" : "REHIRE"
        this.displayPicture =this.displayPicture.bind(this);
    }

    componentDidMount(){
        this.GetApplicationInformation()
    }
    
    GetApplicationInformation = async()=> {
        this.setState({isloading:true})
        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.clientId,
            "UserId":this.state.userinfo.userId,
            "ApplicationId" : this.state.applicationId,
        };
        axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Recruitment/GetApplicationInformation",  params)
            .then(res => {
            const data = res.data;
            
            console.log("this.state.data")
            console.log(data)

            var today = new Date();
            var birthDate = new Date(data.dateOfBirth);
            var age_now = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
            {
                age_now--;
            }
            this.state.totalAge = age_now
            this.state.ageMonth = new Date(data.dateOfBirth).getMonth()+1
            this.state.ageYear = birthDate.getFullYear()
            // start general information
            this.state.profileId = data.profileId
            this.state.applicationFormInfoId= data.id
            this.state.dateApplied  = new Date(data.dateApplied)
            this.state.fName        = data.firstName
            this.state.nName        = data.nickName
            this.state.mName        = data.middleName
            this.state.lName        = data.lastName
            this.state.sName        = data.suffixName
            this.state.titleValue   = data.title
            this.state.hpNumber     = data.homePhoneNumber
            this.state.mobileNumber = data.mobileNumber
            this.state.emailAddress = data.emailAddress
            
            this.state.facebook         = data.facebook
            this.state.twitter          = data.twitter
            this.state.nationalityId    = data.nationalityId
            this.state.nationality    = data.nationality
            this.state.religionId       = data.religionId
            this.state.religion       = data.religion
            this.state.genderValue      = data.gender
            this.state.civilStatusValue = data.civilStatus
            this.state.dateOfBirth      = new Date(data.dateOfBirth)
            this.state.totalAge         = data.age
            
            this.state.placeOfBirth = data.placeOfBirth
            this.state.height       = data.height
            this.state.weight       = data.weight
            this.state.sSkills      = data.specialSkills
            this.state.lSpoken      = data.languageSpoken
            this.state.ecName       = data.emergencyContactName
            this.state.relationship = data.emergencyContactRelation
            this.state.ecNumber     = data.emergencyContactNumber
            
            this.state.sss     = data.sssNumber
            this.state.tin     = data.tinNumber
            this.state.phic    = data.phicNumber
            this.state.pagibig = data.hdmfNumber

            this.state.arrangementId = data.livingArrangementId
            this.state.arrangement = data.livingArrangement
            this.state.bloodtypeId = data.bloodTypeId
            this.state.bloodtype = data.bloodType
            this.state.resumeFileName = data.resume
            this.state.pictureFileName = data.picture
            let a = data.id
            this.GetApplicationFormDetails(a);
            
            if(data.status=="0"){
               this.setState({
                   isloading   :   false,
                   alerttype   :   "Error!",
                   isshow      :   true,
                   color       :   "danger",
                   message     :   data.message,
                   fade        :   true
               });
            }
         })
         .catch(error=>{
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
    }
    
    GetApplicationFormDetails = async(a)=> {
        let b = a
        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.clientId,
            "UserId":this.state.userinfo.userId,
            "ApplicationId" : this.state.applicationId,
        };
        axios
            .post(AppConfiguration.Setting().noserapiendpoint + "Recruitment/GetApplicationFormDetails",  params)
            .then(res => {
            const data = res.data;
            /* if(data.applicantAddresses.length>0){
                this.state.region = data.applicantAddresses[0]["region"]
            } */
            if(data.status==="1"){
                this.setState({
                    wdata2 : data,
                    educationGrid : data.educationAttainments,
                    employmentGrid : data.employmentHistories,
                    fbGrid : data.familyBackgrounds,
                    othersGrid : data.others,
                    referenceGrid : data.characterReferences
                })
                if(data.applicantAddresses.length>0){
                    this.state.addressApplicationFormId= data.applicantAddresses.length>0 ? data.applicantAddresses[0]["applicationFormId"] : ""
                    this.state.addressId=data.applicantAddresses.length>0 ? data.applicantAddresses[0]["id"] : ""
                    this.state.typeId=data.applicantAddresses.length>0 ? data.applicantAddresses[0]["typeId"] : ""
                    this.state.regionId=data.applicantAddresses.length>0 ? data.applicantAddresses[0]["regionId"]: ""
                    this.state.region=data.applicantAddresses.length>0 ? data.applicantAddresses[0]["region"] : ""
                    this.state.provinceId=data.applicantAddresses.length>0 ? data.applicantAddresses[0]["provinceId"] : ""
                    this.state.provinceName=data.applicantAddresses.length>0 ? data.applicantAddresses[0]["province"] : ""
                    this.state.cityId=data.applicantAddresses.length>0 ? data.applicantAddresses[0]["cityId"] : ""
                    this.state.cityName=data.applicantAddresses.length>0 ? data.applicantAddresses[0]["city"] : ""
                    this.state.houseNumber=data.applicantAddresses.length>0 ? data.applicantAddresses[0]["houseNumber"] : ""
                    this.state.street=data.applicantAddresses.length>0 ? data.applicantAddresses[0]["streetName"] : ""
                    this.state.barangay=data.applicantAddresses.length>0 ? data.applicantAddresses[0]["barangay"] : ""
                    this.state.postalCode=data.applicantAddresses.length>0 ? data.applicantAddresses[0]["postalCode"] : ""
                    this.state.addresstype = this.state.typeDDL.filter(x=>x.value===this.state.typeId).name
                }

                // START educationAttainments APPLICATIONID
                for(let x = 0; x < data.educationAttainments.length; x++){
                    this.state.educationApplicationFormId      = data.educationAttainments[x].applicationFormId
                    this.state.educationId      = data.educationAttainments[x].id
                }
                // START employmentHistories APPLICATIONID
                for(let x = 0; x < data.employmentHistories.length; x++){
                    this.state.employmentApplicationFormId      = data.employmentHistories[x].applicationFormId
                    this.state.employmentId      = data.employmentHistories[x].id
                }
                // START familyBackgrounds APPLICATIONID
                for(let x = 0; x < data.familyBackgrounds.length; x++){
                    this.state.familyApplicationFormId      = data.familyBackgrounds[x].applicationFormId
                    this.state.familyId      = data.familyBackgrounds[x].id
                }
                // START others APPLICATIONID
                // for(let x = 0; x < data.others.length; x++){
                //     this.state.othersApplicationFormId      = data.others[x].applicationFormId
                //     this.state.othersId      = data.others[x].id
                // }

                console.log("data.others")
                console.log(data.others)
                data.others.forEach(itm=>{
                    this.state.othersApplicationFormId = itm.applicationFormId
                    this.state.othersId = itm.id
                    this.state.jobSourceId = itm.jobSourceId
                    this.state.jobSource = itm.jobSource
                    this.state.oReferredBy = itm.refferedBy

                    this.state.disablereferral = false
                    this.state.referealOthersTA = itm.jobSourceId ==="10" ? true : false
                    this.state.referealOthersTXT = itm.jobSourceId ==="10" ? false : true


                    this.state.checkORelativeYes = itm.hasCompanyRelative ==="1" ? true : false
                    this.state.checkORelativeNo = itm.hasCompanyRelative ==="1" ? false : true
                    this.state.disabledRelative = itm.hasCompanyRelative ==="1" ? false : true
                    this.state.oRelativeName = itm.relativeName
                    this.state.oRelationship = itm.relativeRelation
                    this.state.oJobTitle = itm.relativePosition
                    this.state.oCNumber = itm.relativeContactNumber
                    

                    this.state.checkConvictedYes = itm.isCrimeConvicted ==="1" ? true : false
                    this.state.checkConvictedNo = itm.isCrimeConvicted ==="1" ? false : true
                    this.state.disabledConvicted = itm.isCrimeConvicted ==="1" ? false : true
                    this.state.oCrime = itm.crimeDescription
                    
                    this.state.checkLaborUnionYes = itm.isLaborUnion ==="1" ? true : false
                    this.state.checkLaborUnionNo = itm.isLaborUnion ==="1" ? false : true
                    this.state.disabledLaborUnion = itm.isLaborUnion ==="1" ? false : true
                    this.state.luDetails = itm.laborUnionDescription

                    this.state.checkChronicDiseaseYes = itm.diagnoseDeseaseId !=="" ? true : false
                    this.state.checkChronicDiseaseNo = itm.diagnoseDeseaseId !=="" ? false : true
                    this.state.disabledDisease = itm.diagnoseDeseaseId !=="" ? false : true
                    this.state.diagnoseDeseaseId = itm.diagnoseDeseaseId
                })

                // START characterReferences APPLICATIONID
                for(let x = 0; x < data.characterReferences.length; x++){
                    this.setState({
                        characterApplicationFormId : data.characterReferences[x].applicationFormId,
                        characterId : data.characterReferences[x].id,
                    })
                    //this.state.characterApplicationFormId      = data.characterReferences[x].applicationFormId
                    //this.state.characterId      = data.characterReferences[x].id
                }
            }
           
           
            if(data.status=="0"){
               this.setState({
                   isloading   :   false,
                   alerttype   :   "Error!",
                   isshow      :   true,
                   color       :   "danger",
                   message     :   data.message,
                   fade        :   true
               });
            }
            
         })
         .catch(error=>{
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
        this.displayPicture(this.state.applicationId)
        //this.GetDocuments()
    }
    displayPicture = async(b) =>{
        if(this.state.pictureFileName===""){
            return
        }
        
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "ApplicationFormId": b,//this.state.applicationFormInfoId,
            "TypeId"        :   "0",
            "FileName"      :   this.state.pictureFileName //"ID_"+this.state.applicationFormInfoId+".JPEG"
        }
        
        await axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Recruitment/DownloadFile", params,{'responseType': 'blob'})
        .then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.state.pictureFileName);
            document.body.appendChild(link);
            //link.click();
            console.log(" res 2x2 pic")
            console.log(res)
            let dataTmp = []
            let a = []
            a.push(res.config)
            console.log(a)
            let b = []
            a.map(function(itm,i){
               b.push(itm.data)
            })   
            console.log(b)
            b.map(function(itm,i){
                const strJson = itm.replace("","").replace("ObjectId(","").replace(")","").replace("","")
                const json = JSON.parse(strJson.replace(/'/g,'"'));
                dataTmp.push(json)
            })    
            console.log(dataTmp)
            let c = []
            let obj
            dataTmp.forEach(element => {
                obj ={ "files" :  [{
                        "type" : "image/jpeg",
                        "name" : element.FileName,
                        "ApplicationFormId" : element.ApplicationFormId,
                        "ClientId": element.ClientId,
                        "FileName": element.FileName,
                        "IpAddress": element.IpAddress,
                        "TypeId": element.TypeId,
                        "UserId": element.UserId,
                        "size": 178628,
                    }]
                }
                c.push(obj)
            });
            this.setState({newImage1 :url,newImageShow : false,photoLabel : true})
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true
            })
        })
        this.GetDocuments()
    };
    GetDocuments = async() =>{
        //this.setState({isloading:true})
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "UserId"        :   this.state.userinfo.userId,
            "ClientId"      :   this.state.data.clientId,
            "PositionId"    :   this.state.data.positionId,
        }
        await axios
            .post(
                AppConfiguration.Setting().noserapiendpoint + "Recruitment/GetDocuments", params
            )
            .then(res => {
                const data = res.data;
                this.setState({documentGRID:data.documents})
            }) 
        this.GetLocations()
    }
    GetLocations = async() =>{
        const params = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.clientId,
            "UserId":this.state.userinfo.userId,
            "ClientName": this.state.clientName,
        }
        axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Client/GetClientLocations", params)
        .then(res => {
            const data = res.data;
            this.setState({locationDDL : data.locations ? data.locations : []})
        })
        .catch(error=>{
           this.setState(  {
               isloading       :   false,
               alerttype       :   "Error!",
               isshow          :   true,
               color           :   "danger",
               message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
               fade            :   true
           })
       })
       this.GetPayrollTypes()
    }
    GetPayrollTypes = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Timekeeping/GetPayrollTypes",  params)
        .then(res => {
            const data = res.data;
            this.setState({paytypeDDL:data.payrollTypes});
        })
        .catch(error=>{
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
        this.GetPayrollModes()
    }
    GetPayrollModes = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Timekeeping/GetPayrollModes",  params)
        .then(res => {
            const data = res.data;
            this.setState({paymodeDDL:data.payrollModes});
        })
        .catch(error=>{
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
        this.GetEmploymentTypes()
    }
    GetEmploymentTypes = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetEmployeeStatusTypes",  params)
        .then(res => {
            const data = res.data;
            this.setState({employmentDDL:data.statusTypes});
        })
        .catch(error=>{
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
        this.GetPayCardTypes()
    }
    GetPayCardTypes = async()=> {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetPayCardTypes",  params)
        .then(res => {
            const data = res.data;
            this.setState({paycardtypeDDL:data.payCardTypes});
        })
        .catch(error=>{
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
        this.GetTaxTypes()
    }
    GetTaxTypes = async() => {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "Code"          :   "0012"
        };

        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetDataReferences",  params)
        .then(res => {
            const data = res.data;
            this.setState({ taxtypeDDL:data.dataReferences });
        })
        .catch(error=>{
            this.setState({
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
        this.GetTaxExemptions()
    }
    GetTaxExemptions = async() => {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "Code"          :   "0013"
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetDataReferences",  params)
        .then(res => {
            const data = res.data;
            this.setState({ taxexemptionDDL:data.dataReferences });
        })
        .catch(error=>{
            this.setState({
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
        this.GetDeductionTypes()
    }
    GetDeductionTypes = async() => {
        const departmentCodeParams = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "Code"          :   "0016"
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetDataReferences",  departmentCodeParams)
        .then(res => {
            const data = res.data;
            this.setState({deductionDDL:data.dataReferences});
        })
        .catch(error=>{
            this.setState({
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
        this.GetBasisFor13Months()
    }
    GetBasisFor13Months = async() => {
        const params = {
            "IpAddress"     :   "0.0.0.0",
            "ClientId"      :   this.state.userinfo.clientId,
            "UserId"        :   this.state.userinfo.userId,
            "Code"          :   "0017"
        };
        await axios.post(AppConfiguration.Setting().noserapiendpoint + "Maintenance/GetDataReferences",  params)
        .then(res => {
            const data = res.data;
            this.setState({basic13thMonthDDL:data.dataReferences,isloading:false});
        })
        .catch(error=>{
            this.setState({
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true
            })
        })
    }
    
    handleChangedDDL = name => e =>{
        this.setState({alerttype:"",isshow:false,color:"",message:"",fade:true,isloading:false});
        if(e.length===0) {this.setState({[name]:""}); return}
        this.setState({[name]:e[0].id})

        if(name==="paycardtypeId" && e[0].id==="4"){
            this.setState({disablecard:true,paycardNumber:""})
        }
        if(name==="paycardtypeId" && e[0].id!=="4"){
            this.setState({disablecard:false})
        }
    }
    handleChangedDate = name => date =>{
        this.setState({[name]:date})
        if(name==="dateHired"){
            this.state.minDate=new Date(date)
            this.state.contractstartDate=new Date(date)
            this.state.contractendDate=new Date(date)
        }
    }
    handleChangedCB = (e) =>{
        this.setState({[e.target.name]: e.target.checked})
    }
    handleChanged = (e) =>{
        if(e.target.name==="salaryRate" ||
            e.target.name==="ecolaRate" ||
            e.target.name==="colaRate" ||
            e.target.name==="seaRate"){
            if(e.target.value.split(".").length>2) return
            let dec = e.target.value.split(".")[1]
            if(typeof dec !='undefined')
                if(dec.length>2) return

        }
        this.setState({[e.target.name]:e.target.value})
    }
    FormatDate(date) {
        let m = moment(date, 'MM/DD/YYYY');
        return (m.isValid() ? (date.getMonth()+1 + "/" + date.getDate() + "/" + date.getFullYear()) : "")
    }
    IsNumeric(evt)
    {
        var theEvent = evt || window.event;
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode( key );
        var regex = /^\d+(.\d+)?$/;
        if( !regex.test(key) ) {
        theEvent.returnValue = false;
        if(theEvent.preventDefault) theEvent.preventDefault();
        }
        
    }
    IsDecimal(evt)
    {
        var theEvent = evt || window.event;
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode( key );
        var regex = /^\d*\.?(?:\d{1,2})?$/;
        if( !regex.test(key) ) {
        theEvent.returnValue = false;
        if(theEvent.preventDefault) theEvent.preventDefault();
        }
    }
    GridDataModified(oldValue, newValue, row, column) {
        let documentGRID = this.state.documentGRID
        documentGRID.map(function(item,i) {
            if (item.id===row.id && newValue!==oldValue)
            {
                if(column==="isReceived" && newValue==="1"){
                    item.isSuspended="0"
                }
                if(column==="isReceived" && newValue==="0"){
                    item.isSuspended="1"
                    item.dateReceived = null
                }

                if(column==="isSuspended" && newValue==="1"){
                    item.isReceived="0"
                    item.dateReceived=null
                }
                if(column==="isSuspended" && newValue==="0"){
                    item.isReceived="1"
                    item.dateReceived = null
                }
                if(typeof item.dateReceived==='undefined')
                    item.dateReceived=null
            }
        })
        this.state.documentGRID = documentGRID
        console.log(this.state.documentGRID)
    }
    handleSubmitClick = async(statusid) => {
        this.setState({isloading:true,disablebutton:true})
        let documentGRID = this.state.documentGRID
        
        if(documentGRID.filter(x=>x.isRequired==="1" && x.isReceived==="1" && x.dateReceived===null).length>0){
            let doc = documentGRID.find(x=>x.isRequired==="1" && x.isReceived==="1" && x.dateReceived===null).name
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "Please enter date received for " + doc + ".",
                fade        :   true,
                disablebutton:  false
            })
            return
        }

        if(documentGRID.filter(x=>x.isRequired==="1" && x.isReceived==="1" && x.isSuspended==="1").length>0){
            let doc = documentGRID.find(x=>x.isRequired==="1" && x.isReceived==="1" && x.isSuspended==="1").name
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   doc + " cannot be submitted, received and suspended column are both YES.",
                fade        :   true,
                disablebutton:  false
            })
            return
        }
        if(documentGRID.filter(x=>x.isRequired==="1" && x.isReceived==="0" && x.isSuspended==="0").length>0){
            let doc = documentGRID.find(x=>x.isRequired==="1" && x.isReceived==="0" && x.isSuspended==="0").name
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   doc + " cannot be submitted, received and suspended column are both NO.",
                fade        :   true,
                disablebutton:  false
            })
            return
        }
        console.log(documentGRID)
        const params = {
            "IpAddress"             :   "0.0.0.0",
            "ClientId"              :   this.state.clientId,
            "UserId"                :   this.state.userinfo.userId,
            "ApplicationFormId"     :   this.state.applicationId,
            "LocationId"            :   this.state.locationId,
            "IsDefaultLocation"     :   (this.state.isdefaultBranch)? "1" : "0",
            "PositionId"            :   this.state.positionId,
            "SalaryOffered"         :   this.state.salaryRate,
            "DateHired"             :   this.FormatDate(this.state.dateHired),
            "ContractDateStart"     :   this.FormatDate(this.state.contractstartDate),
            "ContractDateEnd"       :   this.FormatDate(this.state.contractendDate),
            "PayTypeId"             :   this.state.paytypeId,
            "PayModeId"             :   this.state.paymodeId,
            "EcolaValue"            :   this.state.ecolaRate,
            "SeaValue"              :   this.state.seaRate,
            "ColaValue"             :   this.state.colaRate,
            "TaxExemptionTypeId"    :   this.state.taxexemptionId,
            "TaxTypeId"             :   this.state.taxtypeId,
            "TaxCodeId"             :   "0",
            "IsOBP"                 :   (this.state.isbasicPay)? "1" : "0",
            "WorkingDaysPerMonth"   :   this.state.daysperMonth,
            "WorkingDaysPerYear"    :   this.state.daysperYear,
            "DeductionBasisSSS"     :   this.state.deductionsssId,
            "DeductionBasisHDMF"    :   this.state.deductionhdmfId,
            "DeductionBasisPHIC"    :   this.state.deductionphicId,
            "BasisFor13thMonth"     :   this.state.basic13thmonthId,
            "EmployeeStatusTypeId"  :   this.state.employmentId,
            "PayCardTypeId"         :   this.state.paycardtypeId,
            "PayCardNumber"         :   this.state.paycardNumber,
            "TMNProfileId"          :   "N/A",
            "PreparedBy"            :   this.state.userinfo.userId,
            "Conforme"              :   this.state.userinfo.fullName,
            "ProfileId"             :   this.state.profileId,
            "StatusId"              :   statusid,
            "documents"             :   documentGRID,
        };
        await axios
        .post(AppConfiguration.Setting().noserapiendpoint + "Recruitment/AddJobOffer",  params)
        .then(res => {
                const data = res.data;
            if(data.status=="1"){
                this.setState({
                    isloading   :   false,
                    alerttype   :   "Success!",
                    isshow      :   true,
                    color       :   "success",
                    message     :   data.message,
                    fade        :   true,
                    disablebutton:  true
                });
            
            }
            else {
                this.setState({
                    isloading   :   false,
                    alerttype   :   "Error!",
                    isshow      :   true,
                    color       :   "danger",
                    message     :   data.message,
                    fade        :   true,
                    disablebutton:  false
                });
            }
        })
        .catch(error=>{
            this.setState({
                isloading       :   false,
                alerttype       :   "Error!",
                isshow          :   true,
                color           :   "danger",
                message         :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade            :   true,
                disablebutton:  false
            })
        })
    };

    handleSubmit = async (StatusId) =>{
        this.setState({isloading:true,disableBtn:true})

        const param = {
            "IpAddress":"0.0.0.0",
            "ClientId":this.state.clientId,
            "UserId":this.state.userinfo.userId,
            "ApplicationFormId":this.state.applicationId,
            "PositionId":this.state.positionId,
           /// "IsPooled":ispooled,

            /* "ClientId": "1",
            "IpAddress": "0.0.0.0",
            "UserId": "1",
            "ApplicationFormId": "",
            "PositionId": "" */
            "StatusId": StatusId, /* --> blacklisted - 12, process - 3  */

            "EducationalId":this.state.educationId,
            "IsFreshGrad":(this.state.freshGraduate)? "1" : "0",
            "WorkExperienceMonths":this.state.workExperienceMonths,
            "WorkExperienceYears":this.state.workExperienceYear,
            "WithWorkExperience":(this.state.withWorkExperience)? "1" : "0",
            "BodyBuiltId":this.state.bodyId,
            "HairId":this.state.hairId,
            "ComplexionId":this.state.complexionId,
            "PostureId": this.state.postureId,
            "PersonalityId":this.state.personalityId,
            "MentalId":this.state.mentalId,
            "WorkExperienceId":this.state.professionalId,
            "TechnicalExperienceId":this.state.technicalId,
            "SupportGroupId":this.state.supportGroupId,
            "AssessmentId":this.state.assessmentId,
            "Comments":this.state.comments,
            "RecommendationId":this.state.preFinalId,
            "AssessedBy":this.state.userinfo.userId,
            "StoreOperationId":this.state.storeId,
        };
        console.log("param")
        console.log(param)

        
        await axios
        .post(
            AppConfiguration.Setting().noserapiendpoint + "Pooling/SubmitPooling",  param
        )
        .then(res => {
            const data = res.data;
            this.setState({
                isloading   :   false,
                alerttype   :   res.data.status=="1" ? "Success!" : "!Error",
                isshow      :   true,
                color       :   res.data.status=="1" ? "success" : "danger",
                message     :   data.message,
                fade        :   true,
                name        :   ''
            });
        })
        .catch(error=>{
            this.setState({
                isloading   :   false,
                alerttype   :   "Error!",
                isshow      :   true,
                color       :   "danger",
                message     :   "An error occured while processing your request, Please contact your System Administrator for : " + error.message,
                fade        :   true,
                name        :   ''
            })
        })
    };

    handleConfirm=()=>{
        this.setState({isShow:true})
    };
    handleClose=()=>{
        this.setState({isShow:false, pooling : true})
    }
    handleModalShow = (e) =>{
        let obj = {
            "applicationFormId":this.state.applicationId,
            "positionId":this.state.positionId,
            "clientId" : this.state.clientId,
            "accountId" : "",
            "areaId":this.state.userinfo.areaId,
            "aquisitionId" : "",
            "statusId" : e,
        }
        this.setState({openModal:true})
        this.child.initialize(obj)
    }
    handleModalClose = (e) =>{
        this.setState({openModal:false})
    };
    
    render() {
        const { navigate } = this.state;
        if (navigate) {
            return <Redirect to="/applicationform" push={true} />;
        } 

        const docCol = [
            {
                dataField: 'name',
                text: 'Documents',
                editable : false,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',width:'50%'}},
                style:{textAlign:'left',width:'50%'}
            },
            {
                dataField: 'isRequired',
                text: 'Type',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'15%'}},
                style:{textAlign:'center',width:'15%'},
                formatter: (cell, row) => {
                    if(row.isRequired !=='' || typeof row.isRequired === 'undefined'){
                        if(this.state.requiredDDL.filter(x => x.value == cell).length==0)
                        return ""
                        else
                            return this.state.requiredDDL.find(x => x.value == cell).label;
                    }
                },
                editor: {
                    type: Type.SELECT,
                    options: this.state.requiredDDL
                },
            },
            {
                dataField: 'isReceived',
                text: 'Received',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'10%'}},
                style:{textAlign:'center',width:'10%'},
                formatter: (cell, row) => {
                    if(row.isReceived !=='' || typeof row.isReceived === 'undefined'){
                        //return row.isReceived==="0" ? "N" : "Y"
                        if(this.state.yesNoDDL.filter(x => x.value == cell).length==0)
                        return ""
                        else
                            return this.state.yesNoDDL.find(x => x.value == cell).label;
                    }
                },
                
                editor: {
                    type: Type.SELECT,
                    options: this.state.yesNoDDL
                    // type: Type.CHECKBOX,
                    // value: 'Y:N'
                },
                validator: (newValue, row, column) => {
                    // if (newValue =="1" && row.isSuspended=="1") {
                    //   return {
                    //     valid: false,
                    //     message: "Please select correctly at Column RECEIVED / SUSPENDED"
                    //   };
                    // }
                    // return true;
                }
            },
            {
                
                dataField: 'dateReceived',
                text: 'DATE RECEIVED',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'15%'}},
                style:{textAlign:'center',width:'15%'},
                formatter: (cell) => { 
                    let dateObj = cell;
                    if(cell === "") return
                    if (typeof cell !== 'object') dateObj = new Date(cell);
                    if (cell != null){
                        let m = moment(dateObj);
                        return (m.isValid() ? (dateObj.getMonth()+1 + "/" + dateObj.getDate() + "/" + dateObj.getFullYear()) : "")
                    }
                },
                editor: {
                    type: Type.DATE,
                    defaultValue: Date.now(),
                    minDateValue: Date.now(),
                },
                validator: (newValue, row, column) => {
                    // if (row.isReceived=="0") {
                    //   return {
                    //     valid: false,
                    //     message: "Not allowed"
                    //   };
                    // }
                    // return true;
                }
            },
            {
                dataField: 'isSuspended',
                text: 'Suspended',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center',width:'10%'}},
                style:{textAlign:'center',width:'10%'},
                formatter: (cell, row) => {
                    if(row.isSuspended !=='' || typeof row.isSuspended === 'undefined'){
                        if(this.state.yesNoDDL.filter(x => x.value == cell).length==0)
                        return ""
                        else
                            return this.state.yesNoDDL.find(x => x.value == cell).label;
                    }
                },
                editor: {
                    type: Type.SELECT,
                    options: this.state.yesNoDDL
                },
                validator: (newValue, row, column) => {
                    // if (newValue =="1" && row.isReceived=="1") {
                    //   return {
                    //     valid: false,
                    //     message: "Please select correctly at Column RECEIVED / SUSPENDED"
                    //   };
                    // }
                    // return true;
                }
            },
                
        ] 
    
        const selectRow = {
            mode: 'checkbox',
            clickToSelectAndEditCell: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                
            }
        };
        const rowEvents = {
            onClick: (e, row, rowIndex) => {

            }
        };

        const educationCols = [
            {
                dataField: 'levelId',
                text: 'Level',
                headerStyle: () => {
                    return { width: "14%" };
                },
                formatter: (cell, row) => {
                    if(row.levelId!='' && row.levelId!=null){
                        if(this.state.educationDDL.filter(x => x.value == cell).length==0)
                             return ""
                        else
                         return this.state.educationDDL.find(x => x.value == cell).name;
                    }
                }
            },
            {
                dataField: 'schoolName',
                text: 'School Name',
                ediatable : false,
                headerStyle: () => {
                    return { width: "30%" };
                  }
            },
            {
                dataField: 'course',
                text: 'Course',
                headerStyle: () => {
                    return { width: "20%" };
                  }
            },
            {
                dataField: 'startYear',
                text: 'Start Year',
                headerStyle: () => {
                    return { width: "10%" };
                }
            },
            {
                dataField: 'endYear',
                text: 'End Year',
                headerStyle: () => {
                    return { width: "10%" };
                  }
            },
            {
                dataField: 'honorRecieved',
                text: 'Honor Recieved',
                headerStyle: () => {
                    return { width: "16%" };
                }
            },
        ]
        const employmentCols = [
            {
                dataField: 'companyName',
                text: 'Company_Name',
                headerStyle: () => {
                    return { width: "19%" };
                }
            },
            {
                dataField: 'companyAddress',
                text: 'Company_Address',
                headerStyle: () => {
                    return { width: "14%" };
                }
            },
            {
                dataField: 'position',
                text: 'Position',
                headerStyle: () => {
                    return { width: "14%" };
                }
            },
            {
                dataField: 'periodStart',
                text: 'Period Start',
                headerStyle: () => {
                    return { width: "10%",textAlign: 'center' };
                },
                style:{textAlign:'center',width:'10%'}
            },
            {
                dataField: 'periodEnd',
                text: 'Period End',
                headerStyle: () => {
                    return { width: "10%",textAlign: 'center' };
                },
                style:{textAlign:'center',width:'10%'}
            },
            {
                dataField: 'salary',
                text: 'Salary',
                headerStyle: () => {
                    return { width: "15%" };
                },
                style:{textAlign:'right',whiteSpace:'nowrap'}
            },
            {
                dataField: 'reasonForLeaving',
                text: 'Reason for Leaving',
                headerStyle: () => {
                    return { width: "22%" };
                }
            }
        ]
        const fbCols = [
            {
                dataField: 'roleId',
                text: 'Role',
                headerStyle: () => {
                    return { width: "14%" };
                },
                formatter: (cell, row) => {
                    if(row.roleId!='' && row.roleId!=null){
                        if(this.state.fbDDL.filter(x => x.value == cell).length==0)
                             return ""
                        else
                         return this.state.fbDDL.find(x => x.value == cell).name;
                    }
                }
            },
            {
                dataField: 'name',
                text: 'Name',
                headerStyle: () => {
                    return { width: "19%" };
                }
            },
            {
                dataField: 'contactNumber',
                text: 'Contact Number',
                headerStyle: () => {
                    return { width: "14%" };
                }
            },
            {
                dataField: 'age',
                text: 'Age',
                headerStyle: () => {
                    return { width: "8%" };
                }
            },
            {
                dataField: 'occupation',
                text: 'Occupation',
                headerStyle: () => {
                    return { width: "19%" };
                }
            },
            {
                dataField: 'company',
                text: 'Company',
                headerStyle: () => {
                    return { width: "26%" };
                }
            }
        ]
        const referenceCols = [
            {
                dataField: 'typeId',
                text: 'type of character reference',
                headerStyle: () => {
                    return { width: "15%" };
                },
                formatter: (cell, row) => {
                    if(row.typeId!='' && row.typeId!=null){
                        if(this.state.referenceDDL.filter(x => x.value == cell).length==0)
                             return ""
                        else
                         return this.state.referenceDDL.find(x => x.value == cell).name;
                    }
                }
            },
            {
                dataField: 'name',
                text: 'Name',
                headerStyle: () => {
                    return { width: "25%" };
                },
                validator: (newValue, row, column) => {
                    if(row.endYear==="")
                        return {
                        valid: false,
                        message:"Please enter occupation."
                    };
                    return true;   
                }
            },
            {
                dataField: 'contactNumber',
                text: 'Contact Number',
                headerStyle: () => {
                    return { width: "20%" };
                }
            },
            {
                dataField: 'occupation',
                text: 'Occupation',
                headerStyle: () => {
                    return { width: "25%" };
                }
            },
            {
                dataField: 'company',
                text: 'Company',
                headerStyle: () => {
                    return { width: "30%" };
                }
            }
        ]
        const gselectRow = {
            mode: 'checkbox',
            hideSelectAll: true,
            clickToSelectAndEditCell: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                
            }
        }
        return(
            <div>
                <Banner />
                    <Container className="mt-5" fluid>
                        <Card>
                            <Card.Header>RECRUITMENT >> JOB OFFER (CREATE)</Card.Header>
                            <Card.Body  className="mb-3">
                                <Form >
                                    <Alert isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isshow ? 'display-block' : 'display-none'}>
                                        <div className={this.state.color}></div> 
                                        {this.state.message}
                                    </Alert>
                                    <Tabs className="mt-2" defaultActiveKey="default" transition={false} id="noanim-tab-example">
                                        <Tab eventKey="default" title="JOB OFFER DETAILS">
                                        <Card className="card-tab-no-border">
                                        <Card.Body>
                                        <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        CLIENT
                                        </Form.Label>
                                        <Col sm="3">
                                            <Form.Control 
                                                type="text" 
                                                autoComplete="off" 
                                                name="clientName"
                                                value={this.state.clientName}
                                                readOnly
                                            /> 
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        FULL NAME
                                        </Form.Label>
                                        <Col sm="3">
                                            <Form.Control 
                                                type="text" 
                                                autoComplete="off" 
                                                name="employeeName"
                                                value={this.state.employeeName}
                                                readOnly
                                            /> 
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        POSITION APPLIED
                                        </Form.Label>
                                        <Col sm="3">
                                            <Form.Control 
                                                type="text" 
                                                autoComplete="off" 
                                                name="position"
                                                value={this.state.position}
                                                readOnly
                                            /> 
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        BRANCH
                                        </Form.Label>
                                        <Col sm="3">
                                            <Typeahead
                                                labelKey='name'
                                                id="basic-example"
                                                name="locationId"
                                                onChange={this.handleChangedDDL('locationId')}
                                                options={this.state.locationDDL}
                                                readOnly
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Col sm="5">
                                            <Form.Check 
                                                type="checkbox" 
                                                label="Is Default Branch" 
                                                name="isdefaultBranch"
                                                onChange={e => this.handleChangedCB(e)}
                                                style={{fontWeight : "bold"}}
                                            />
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        EMPLOYEE STATUS TYPE
                                        </Form.Label>
                                        <Col sm="3">
                                            <Typeahead
                                                labelKey='name'
                                                id="basic-example"
                                                name="employmentId"
                                                onChange={this.handleChangedDDL('employmentId')}
                                                options={this.state.employmentDDL}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        SALARY OFFERED
                                        </Form.Label>
                                        <Col sm="3">
                                            <Form.Control 
                                                ref="salaryRate"
                                                name="salaryRate"
                                                value={this.state.salaryRate}
                                                onChange={this.handleChanged}
                                                onKeyPress={this.IsDecimal.bind(this)}
                                                maxLength="13"
                                                autoComplete="off"
                                            />
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        DATE HIRED
                                        </Form.Label>
                                        <Col sm="2">
                                            <DatePicker
                                                ref='dateHired'
                                                selected={this.state.dateHired}
                                                onChange={this.handleChangedDate("dateHired")}
                                                minDate={this.state.minDate}
                                                value={this.props.dateHired}
                                                dateFormat={"MM/dd/yyyy"}
                                                className="form-control"
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        CONTRACT DATE START
                                        </Form.Label>
                                        <Col sm="3">
                                            <DatePicker
                                                ref='contractstartDate'
                                                selected={this.state.contractstartDate}
                                                onChange={this.handleChangedDate("contractstartDate")}
                                                minDate={this.state.minDate}
                                                value={this.props.contractstartDate}
                                                dateFormat={"MM/dd/yyyy"}
                                                className="form-control"
                                            />
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        CONTRACT DATE END
                                        </Form.Label>
                                        <Col sm="3">
                                            <DatePicker
                                                ref='contractendDate'
                                                selected={this.state.contractendDate}
                                                onChange={this.handleChangedDate("contractendDate")}
                                                minDate={this.state.minDate}
                                                value={this.props.contractendDate}
                                                dateFormat={"MM/dd/yyyy"}
                                                className="form-control"
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        PAY TYPE
                                        </Form.Label>
                                        <Col sm="3">
                                            <Typeahead
                                                labelKey='name'
                                                id="paytypeId"
                                                name="paytypeId"
                                                onChange={this.handleChangedDDL('paytypeId')}
                                                options={this.state.paytypeDDL}
                                            />
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        PAY MODE
                                        </Form.Label>
                                        <Col sm="3">
                                            <Typeahead
                                                labelKey='name'
                                                id="paymodeId"
                                                name="paymodeId"
                                                onChange={this.handleChangedDDL('paymodeId')}
                                                options={this.state.paymodeDDL}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        PAY CARD TYPE
                                        </Form.Label>
                                        <Col sm="3">
                                            <Typeahead
                                                labelKey='name'
                                                id="paycardtypeId"
                                                name="paycardtypeId"
                                                onChange={this.handleChangedDDL('paycardtypeId')}
                                                options={this.state.paycardtypeDDL}
                                            />
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        PAY CARD NUMBER
                                        </Form.Label>
                                        <Col sm="3">
                                            <Form.Control 
                                                ref="paycardNumber"
                                                name="paycardNumber"
                                                value={this.state.paycardNumber}
                                                onChange={this.handleChanged}
                                                disabled={this.state.disablecard}
                                                autoComplete="off"
                                                maxLength="30"
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        TMN PROFILE ID
                                        </Form.Label>
                                        <Col sm="3">
                                            <Typeahead
                                                labelKey='name'
                                                id="tmnprofileId"
                                                name="tmnprofileId"
                                                onChange={this.handleChangedDDL('tmnprofileId')}
                                                options={this.state.tmnprofileDDL}
                                            />
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        ECOLA
                                        </Form.Label>
                                        <Col sm="3">
                                            <Form.Control 
                                                ref="ecolaRate"
                                                name="ecolaRate"
                                                value={this.state.ecolaRate}
                                                onChange={this.handleChanged}
                                                onKeyPress={this.IsDecimal.bind(this)}
                                                autoComplete="off"
                                                maxLength="13"
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        SEA
                                        </Form.Label>
                                        <Col sm="3">
                                            <Form.Control 
                                                ref="seaRate"
                                                name="seaRate"
                                                value={this.state.seaRate}
                                                onChange={this.handleChanged}
                                                onKeyPress={this.IsDecimal.bind(this)}
                                                autoComplete="off"
                                                maxLength="13"
                                            />
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        COLA
                                        </Form.Label>
                                        <Col sm="3">
                                            <Form.Control 
                                                ref="colaRate"
                                                name="colaRate"
                                                value={this.state.colaRate}
                                                onChange={this.handleChanged}
                                                onKeyPress={this.IsDecimal.bind(this)}
                                                autoComplete="off"
                                                maxLength="13"
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        TAX EXEMPTION
                                        </Form.Label>
                                        <Col sm="3">
                                            <Typeahead
                                                labelKey='name'
                                                id="taxexemptionId"
                                                name="taxexemptionId"
                                                onChange={this.handleChangedDDL('taxexemptionId')}
                                                options={this.state.taxexemptionDDL}
                                            />
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        TAX TYPE
                                        </Form.Label>
                                        <Col sm="3">
                                            <Typeahead
                                                labelKey='name'
                                                id="taxtypeId"
                                                name="taxtypeId"
                                                onChange={this.handleChangedDDL('taxtypeId')}
                                                options={this.state.taxtypeDDL}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Col sm="5">
                                            <Form.Check 
                                                type="checkbox" 
                                                label="Is Optimized Basic Pay" 
                                                id="isbasicPay"
                                                name="isbasicPay"
                                                onChange={e => this.handleChangedCB(e)}
                                                style={{fontWeight : "bold"}}
                                            />
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        ALPHANUMERIC TAX CODE
                                        </Form.Label>
                                        <Col sm="3">
                                            <Typeahead
                                                labelKey='name'
                                                id="taxcodeId"
                                                name="taxcodeId"
                                                onChange={this.handleChangedDDL('taxcodeId')}
                                                options={this.state.taxcodeDDL}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        DEDUCTION BASIS SSS
                                        </Form.Label>
                                        <Col sm="3">
                                            <Typeahead
                                                labelKey='name'
                                                id="deductionsssId"
                                                name="deductionsssId"
                                                onChange={this.handleChangedDDL('deductionsssId')}
                                                options={this.state.deductionDDL}
                                            />
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        DEDUCTION BASIS HDMF
                                        </Form.Label>
                                        <Col sm="3">
                                            <Typeahead
                                                labelKey='name'
                                                id="deductionhdmfId"
                                                name="deductionhdmfId"
                                                onChange={this.handleChangedDDL('deductionhdmfId')}
                                                options={this.state.deductionDDL}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        DEDUCTION BASIS PHIC
                                        </Form.Label>
                                        <Col sm="3">
                                            <Typeahead
                                                labelKey='name'
                                                id="deductionphicId"
                                                name="deductionphicId"
                                                onChange={this.handleChangedDDL('deductionphicId')}
                                                options={this.state.deductionDDL}
                                            />
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        BASIS FOR 13th MONTH
                                        </Form.Label>
                                        <Col sm="3">
                                            <Typeahead
                                                labelKey='name'
                                                id="basic13thmonthId"
                                                name="basic13thmonthId"
                                                onChange={this.handleChangedDDL('basic13thmonthId')}
                                                options={this.state.basic13thMonthDDL}
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        WORKING DAYS PER MONTH
                                        </Form.Label>
                                        <Col sm="3">
                                            <Form.Control 
                                                ref="daysperMonth"
                                                name="daysperMonth"
                                                value={this.state.daysperMonth}
                                                onChange={this.handleChanged}
                                                autoComplete="off"
                                            />
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        WORKING DAYS PER YEAR
                                        </Form.Label>
                                        <Col sm="3">
                                            <Form.Control 
                                                ref="daysperYear"
                                                name="daysperYear"
                                                value={this.state.daysperYear}
                                                onChange={this.handleChanged}
                                                autoComplete="off"
                                            />
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row} controlId="formPlaintextEmail">
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        APPLICATION STATUS
                                        </Form.Label>
                                        <Form.Label column sm="4" style={{fontWeight : "bold"}}>{this.state.applicationStatus}</Form.Label>
                                    </Form.Group>
                                    <Card.Header className="mt-5">EMPLOYEE LIST OF REQUIREMENTS</Card.Header>
                                    <div >
                                        <BootstrapTable
                                            keyField = "id"
                                            data = { this.state.documentGRID }
                                            columns = { docCol }
                                            pagination={ paginationFactory({sizePerPageRenderer}) }
                                            noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                                            rowClasses="noser-table-row-class no-checkbox"
                                            striped
                                            hover
                                            condensed
                                            cellEdit = { cellEditFactory({
                                                mode: 'dbclick',
                                                blurToSave: true,
                                                afterSaveCell: (oldValue, newValue, row, column) => {
                                                        this.GridDataModified(oldValue, newValue, row, column.dataField)
                                                    }
                                                })
                                            }
                                            selectRow = { selectRow }
                                            rowEvents={ rowEvents }
                                        />
                                    </div>
                                        </Card.Body>
                                        </Card>
                                        
                                        </Tab>
                                        <Tab eventKey="generalinfo" title="I. GENERAL INFORMATION">
                                            <Card className="card-tab-no-border">
                                                <Card.Body>
                                                <Form.Row>
                                                        <Form.Group as={Col} controlId="formGridAddress1">
                                                            <Form.Label style={{fontWeight : "bold"}}></Form.Label>
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            {/* <div className='mt-2  photoAFC'>
                                                                
                                                                    <div className='aa'>
                                                                        <div color={this.state.color} fade={this.state.fade} className={this.state.photoLabel ? 'display-block' : 'display-none'}>
                                                                            <img width={200} height={200} className='photoAdjust' src={this.state.newImage1} alt="" />
                                                                        </div>
                                                                        <div color={this.state.color} fade={this.state.fade} className={this.state.newImageShow ? 'display-block' : 'display-none'}>
                                                                            <img src={this.state.newImage} alt="" />
                                                                        </div>
                                                                    </div>
                                                                
                                                            </div> */}
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="formGridAddress1">
                                                            <Form.Label style={{fontWeight : "bold"}}>TITLE</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.titleValue}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>NICK NAME</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.nName}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>FIRST NAME</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.fName}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>MIDDLE NAME</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.mName}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>LAST NAME</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.lName}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>SUFFIX NAME</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.sName}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>DATE OF BIRTH</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.dateOfBirth}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>AGE</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.totalAge}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row> 
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>SSS #</Form.Label>
                                                                <Form.Control 
                                                                    type="text"
                                                                    name="nName"
                                                                    value={this.state.sss}
                                                                    disabled
                                                                />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>TIN #</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.tin}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>PHILHEALTH #</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.phic}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>PAGIBIG #</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.pagibig}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>TYPE</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.addresstype}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>REGION</Form.Label>
                                                                <Form.Control 
                                                                    type="text"
                                                                    name="nName"
                                                                    value={this.state.region}
                                                                    disabled
                                                                />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>PROVINCE</Form.Label>
                                                                <Form.Control 
                                                                    type="text"
                                                                    name="nName"
                                                                    value={this.state.provinceName}
                                                                    disabled
                                                                />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>CITY/MUNICIPALITY</Form.Label>
                                                                <Form.Control 
                                                                    type="text"
                                                                    name="nName"
                                                                    value={this.state.cityName}
                                                                    disabled
                                                                />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>HOUSE NUMBER</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="houseNumber"
                                                                value={this.state.houseNumber}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>STREET</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="street"
                                                                value={this.state.street}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>BARANGAY</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="barangay"
                                                                value={this.state.barangay}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>POSTAL CODE</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="postalCode"
                                                                value={this.state.postalCode}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>HOME PHONE NUMBER</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="hpNumber"
                                                                value={this.state.hpNumber}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>OFFICE PHONE NUMBER</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="opNumber"
                                                                value={this.state.opNumber}
                                                                disabled  
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>MOBILE NUMBER</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="mobileNumber"
                                                                value={this.state.mobileNumber}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formBasicEmail">
                                                            <Form.Label style={{fontWeight : "bold"}}>EMAIL ADDRESS</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="emailAddress"
                                                                value={this.state.emailAddress}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>FACEBOOK</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="facebook"
                                                                value={this.state.facebook}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>TWITTER</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="twitter"
                                                                value={this.state.twitter}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridAddress1">
                                                            <Form.Label style={{fontWeight : "bold"}}>CITIZENSHIP</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.nationality}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridAddress1">
                                                            <Form.Label style={{fontWeight : "bold"}}>RELIGION</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.religion}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridAddress1">
                                                            <Form.Label style={{fontWeight : "bold"}}>GENDER</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.genderValue}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridAddress1">
                                                            <Form.Label style={{fontWeight : "bold"}}>CIVIL STATUS</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.civilStatusValue}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>LIVING ARRANGEMENT</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.arrangement}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>BLOOD TYPE</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="nName"
                                                                value={this.state.bloodtype}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>PLACE OF BIRTH</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="placeOfBirth"
                                                                value={this.state.placeOfBirth}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>HEIGHT</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="height"
                                                                value={this.state.height}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>WEIGHT</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="weight"
                                                                value={this.state.weight}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>SPECIAL SKILLS</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="sSkills"
                                                                value={this.state.sSkills}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>LANGUAGE SPOKEN</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="lSpoken"
                                                                value={this.state.lSpoken}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>EMERGENCY CONTACT NAME</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="ecName"
                                                                value={this.state.ecName}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>RELATIONSHIP</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="relationship"
                                                                value={this.state.relationship}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>EMERGENCY CONTACT NUMBER</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="ecNumber"
                                                                value={this.state.ecNumber}
                                                                placeholder="Enter Emergency Contact Number"
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Card.Body>
                                            </Card>
                                        </Tab>
                                        <Tab eventKey="education" title="II. EDUCATION">
                                            <Card className="card-tab-no-border">
                                                <Card.Body>
                                                    <div className="mt-1">  
                                                        <div>
                                                            <Card.Header>EDUCATION LIST</Card.Header>
                                                            <BootstrapTable
                                                                keyField = "id"
                                                                data = { this.state.educationGrid }
                                                                columns = { educationCols }
                                                                noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                                                                rowClasses="noser-table-row-class no-checkbox"
                                                                striped
                                                                hover
                                                                condensed
                                                                selectRow={gselectRow}
                                                                />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Tab>
                                        <Tab eventKey="employment" title=" III. EMPLOYMENT RECORD (START WITH LATEST EMPLOYER)">
                                            <Card className="card-tab-no-border">
                                                <Card.Body>
                                                    <div className="mt-1">  
                                                        <div>
                                                            <Card.Header>EMPLOYMENT RECORDS LIST</Card.Header>
                                                            <BootstrapTable
                                                                keyField = "id"
                                                                data = { this.state.employmentGrid }
                                                                columns = { employmentCols }
                                                                noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                                                                rowClasses="noser-table-row-class no-checkbox"
                                                                striped
                                                                hover
                                                                condensed
                                                                selectRow={gselectRow}
                                                            />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Tab>

                                        <Tab eventKey="familybackground" title="IV. FAMILY BACKGROUND">
                                            <Card className="card-tab-no-border">
                                                <Card.Body>
                                                    <div className="mt-1">  
                                                        <div>
                                                            <Card.Header>Family Background List</Card.Header>
                                                            <BootstrapTable
                                                                keyField = "id"
                                                                data = { this.state.fbGrid }
                                                                columns = { fbCols }
                                                                noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                                                                rowClasses="noser-table-row-class no-checkbox"
                                                                striped
                                                                hover
                                                                condensed
                                                                selectRow={gselectRow}
                                                                />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>   
                                        </Tab>
                                                                
                                        <Tab eventKey="others" title="V. OTHERS">
                                            <Card className="card-tab-no-border">
                                                <Card.Body>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>HOW DID YOU LEARN ABOUT THIS JOB OPENING ?</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                autoComplete="off" 
                                                                name="clientName"
                                                                value={this.state.jobSource}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>Member Referral</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                autoComplete="off" 
                                                                name="oReferredBy"
                                                                value={this.state.oReferredBy}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <hr/>
                                                    <div style={{height : 5}}></div>
                                                    <Form.Row className="mt-3">
                                                        <Form.Group as={Col} sm="5" controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>DO YOU HAVE RELATIVES OR FRIENDS PRESENTLY CONNECTED WITH THIS COOPERATIVE ?</Form.Label>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formBasicCheckbox">
                                                            <Form.Check
                                                                inline 
                                                                type="checkbox" 
                                                                label="YES" 
                                                                name="checkORelativeYes"
                                                                checked={this.state.checkORelativeYes}
                                                                style={{fontWeight : "bold", marginTop : "3px"}}
                                                                disabled
                                                            />
                                                            <Form.Check 
                                                                inline
                                                                type="checkbox" 
                                                                label="NO" 
                                                                name="checkORelativeNo"
                                                                checked={this.state.checkORelativeNo}
                                                                style={{fontWeight : "bold", marginTop : "3px", marginLeft : 12}}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>NAME</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="oRelativeName"
                                                                value={this.state.oRelativeName}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>CONTACT NUMBER</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="oCNumber"
                                                                value={this.state.oCNumber}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>RELATIONSHIP</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="oRelationship"
                                                                value={this.state.oRelationship}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                        <Form.Group as={Col} sm="1" controlId="formGridCity">
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>JOB TITLE</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="oJobTitle"
                                                                value={this.state.oJobTitle}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <hr/>
                                                    <div style={{height : 5}}></div>
                                                    <Form.Row className="mt-3">
                                                        <Form.Group as={Col} sm="3" controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>HAVE YOU BEEN CONVICTED OF A CRIME ?</Form.Label>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formBasicCheckbox">
                                                            <Form.Check
                                                                inline 
                                                                type="checkbox" 
                                                                label="YES" 
                                                                name="checkConvictedYes"
                                                                checked={this.state.checkConvictedYes}
                                                                style={{fontWeight : "bold", marginTop : "3px"}}
                                                                disabled
                                                            />
                                                            <Form.Check 
                                                                inline
                                                                type="checkbox" 
                                                                label="NO" 
                                                                name="checkConvictedNo"
                                                                checked={this.state.checkConvictedNo}
                                                                style={{fontWeight : "bold", marginTop : "3px", marginLeft : 12}}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>IF YES, PLEASE GIVE DETAILS</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="oCrime"
                                                                value={this.state.oCrime}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <hr/>
                                                    <div style={{height : 5}}></div>
                                                    <Form.Row className="mt-3">
                                                        <Form.Group as={Col} sm="3" controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>HAVE YOU BEEN A MEMBER OF A LABOR UNION ?</Form.Label>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formBasicCheckbox">
                                                            <Form.Check
                                                                inline 
                                                                type="checkbox" 
                                                                label="YES" 
                                                                name="checkLaborUnionYes"
                                                                checked={this.state.checkLaborUnionYes}
                                                                style={{fontWeight : "bold", marginTop : "3px"}}
                                                                disabled
                                                            />
                                                            <Form.Check 
                                                                inline
                                                                type="checkbox" 
                                                                label="NO" 
                                                                name="checkLaborUnionNo"
                                                                checked={this.state.checkLaborUnionNo}
                                                                style={{fontWeight : "bold", marginTop : "3px", marginLeft : 12}}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row className="mt-2">
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>IF YES, GIVE DETAILS</Form.Label>
                                                            <Form.Control 
                                                                type="text"
                                                                name="luDetails"
                                                                value={this.state.luDetails}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <hr/>
                                                    <div style={{height : 5}}></div>
                                                    <Form.Row className="mt-3">
                                                        <Form.Group as={Col} sm="6" controlId="formGridCity">
                                                            <Form.Label style={{fontWeight : "bold"}}>HAVE YOU SUFFERED OR BEEN DIAGNOSED TO HAVE ANY OF THE FF. CHRONIC DISEASE(S) OR LIKES ?</Form.Label>
                                                        </Form.Group>
                                                        <Form.Group as={Col} controlId="formBasicCheckbox">
                                                            <Form.Check
                                                                inline 
                                                                type="checkbox" 
                                                                label="YES" 
                                                                name="checkChronicDiseaseYes"
                                                                checked={this.state.checkChronicDiseaseYes}
                                                                style={{fontWeight : "bold", marginTop : "3px"}}
                                                                disabled
                                                            />
                                                            <Form.Check 
                                                                inline
                                                                type="checkbox" 
                                                                label="NO" 
                                                                name="checkChronicDiseaseNo"
                                                                checked={this.state.checkChronicDiseaseNo}
                                                                style={{fontWeight : "bold", marginTop : "3px", marginLeft : 12}}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                    <Form.Row >
                                                        <Form.Group as={Col} controlId="formGridCity">
                                                            <Form.Control 
                                                                type="text" 
                                                                autoComplete="off" 
                                                                name="oReferredBy"
                                                                value={this.state.diagnoseDeseaseId}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Form.Row>
                                                </Card.Body>
                                            </Card>
                                                
                                        </Tab>
                                        
                                        <Tab eventKey="reference" title="VI. REFERENCES (NOT RELATED TO YOUR FAMILY)">
                                            <Card className="card-tab-no-border">
                                                <Card.Header>Reference List</Card.Header>
                                                            <BootstrapTable
                                                                keyField = "id"
                                                                data = { this.state.referenceGrid }
                                                                columns = { referenceCols }
                                                                noDataIndication={ () => <div style={{width:'100%'}}>No record found.</div> }
                                                                rowClasses="noser-table-row-class no-checkbox"
                                                                striped
                                                                hover
                                                                condensed
                                                                selectRow={gselectRow}
                                                            />
                                            </Card>
                                                
                                        </Tab>
                                    </Tabs>
                                    
                                    <Form.Group as={Row} controlId="formPlaintextEmail" className="mt-3">
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        ASSESSED BY
                                        </Form.Label>
                                        <Col sm="3">
                                            <Form.Control 
                                                type="text" 
                                                autoComplete="off" 
                                                /* name="selectedClient" */
                                                value={this.state.userinfo.fullName}
                                                readOnly
                                            /> 
                                        </Col>
                                        <Col sm="2">
                                        </Col>
                                        <Form.Label column sm="2" style={{fontWeight : "bold"}}>
                                        CONFORME
                                        </Form.Label>
                                        <Col sm="3">
                                            <Form.Control 
                                                ref="conforme"
                                                name="conforme"
                                                value={this.state.employeeName}
                                                autoComplete="off"
                                                readOnly
                                            />  
                                        </Col>
                                    </Form.Group>
                                    <div isOpen={this.state.isshow} color={this.state.color} fade={this.state.fade} className={this.state.isShow ? 'display-block' : 'display-none'}>
                                        <Card>
                                            <Card.Body>
                                            <h5 className='no-text-transform'>are you sure you want to blacklist this applicant?</h5>
                                            <ButtonToolbar >
                                                
                                                <Button variant="primary" className="noser-button-mr1 ml-auto" onClick = {() => this.handleSubmit('12')} disabled={this.state.disableBtn}>confirm</Button>
                                                
                                                <Button variant="danger" className="noser-button-mr15" onClick={this.handleClose}>Close</Button>
                                            </ButtonToolbar>
                                            </Card.Body>
                                        </Card>

                                    </div>
                                    <ButtonToolbar className="mt-3">
                                        {/* <Button className="ml-auto noser-button-mr1" variant="success" onClick = {() => this.handleSubmitClick('1')}>Save</Button> */}
                                        <Button variant="warning" className="ml-auto noser-button-mr1" onClick = {() => this.handleModalShow('10')}>POOLING</Button>
                                        <Button variant="dark" className="noser-button-mr1" onClick = { () => this.handleModalShow('12')}>Blacklisted</Button>
                                        <Button className="noser-button-mr1"   variant="primary" onClick = {() => this.handleSubmitClick('2')}>Submit</Button>                                    
                                        <NavLink to="/applicationform">
                                            <Button  className="noser-button noser-button-mr1" variant="danger">Back</Button>
                                        </NavLink>
                                    </ButtonToolbar>
                                    
                                    {/* <ButtonToolbar>
                                    <   Button variant="dark" className="ml-auto noser-button-mr1" onClick = {() => this.handleSubmit('12')}>POOLING</Button>
                                        <Button disabled={this.state.disablebutton}  className=" noser-button-mr1" variant="success" onClick = {() => this.handleSubmitClick('1')}>Save</Button>
                                        <Button disabled={this.state.disablebutton} className="noser-button-mr1"   variant="primary" onClick = {() => this.handleSubmitClick('2')}>Submit</Button>
                                        <Button  href="/applicationform" className="noser-button" variant="danger">Back</Button>
                                    </ButtonToolbar> */}
                                </Form>
                            </Card.Body>
                        </Card>
                    </Container>
                <NoserLoading show={this.state.isloading} />
                <BlacklistModal 
                    show={this.state.openModal}
                    onHide={this.handleModalClose}
                    onRefModal={ref => (this.child = ref)}
                />
            </div> 
        )
    }

}

export  default JobOfferCreate
